import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import BoardDetail from "./board-details";
import LoaderWrapper from "../../components/common/loader/loader-wrapper";
import { getElement } from "../../api/config";
import { getPathParam } from "../../utils/converter";
import { BOARD, COMPANY } from "../endpoints";
import * as Endpoint from "../endpoints";

const BoardPage = () => {
  const { id } = useParams();
  const { loggedCompany } = useSelector((state) => state.user);
  const [boardData, setBoardData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (!loggedCompany || !id) {
      return;
    }

    const controller = new AbortController();
    const signal = controller.signal;

    const fetchBoard = async () => {
      setLoading(true);
      setHasError(false);
      try {
        const res = await getElement(getPathParam([COMPANY, loggedCompany.id, BOARD, id]), signal);
        setBoardData(res);
      } catch (e) {
        if (!signal.aborted) {
          setBoardData(null);
          setHasError(true);
        }
      } finally {
        if (!signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchBoard();

    return () => {
      controller.abort();
    };
  }, [id, loggedCompany]);

  const handleClose = () => {
    navigate(Endpoint.BOARDS);
  };

  const handleRemoved = () => {
    navigate(Endpoint.BOARDS);
  };

  return (
    <div className="min-h-screen bg-solitude-100">
      <LoaderWrapper isLoading={isLoading}>
        {boardData ? (
          <BoardDetail
            isOpenPanel={true}
            setOpenPanel={handleClose}
            boardData={boardData}
            onUpdateBoard={handleRemoved}
            panelVariant="page"
          />
        ) : (
          hasError && (
            <div className="px-4 py-10 text-center text-sm text-gray-500">
              {t("app.board.not_found")}
            </div>
          )
        )}
      </LoaderWrapper>
    </div>
  );
};

export default BoardPage;
